const ru = {
  // ── Common ────────────────────────────────────────────────────────
  common: {
    cancel: 'ОТМЕНА',
    close: 'ЗАКРЫТЬ',
    apply: '✔ ПРИМЕНИТЬ',
    save: 'СОХРАНИТЬ',
    saving: 'СОХРАНЕНИЕ...',
    loading: 'ЗАГРУЗКА...',
    go: 'ПЕРЕЙТИ',
    coordsPlaceholder: 'x, y',
    copied: '✓ СКОПИРОВАНО',
    share: '⎘ ПОДЕЛИТЬСЯ',
    backToMap   : 'На холст',
    error       : 'ОШИБКА: {{msg}}',
    navDashboard: 'МОИ ПИКСЕЛИ',
    navProfile  : 'ПРОФИЛЬ',
    navShop     : 'ПОДПИСКА',
    navZones    : 'МОИ ЗОНЫ',
    navAdmin    : 'АДМИН',
    navLogout   : 'ВЫЙТИ',
    navPlay     : '▶ ИГРАТЬ',
    ofertaLink  : 'публичной офертой',
    ofertaConsent: 'Нажимая кнопку оплаты, вы соглашаетесь с',
    ofertaNotice : 'Используя личный кабинет, вы принимаете условия',
  },

  // ── Auth pages ────────────────────────────────────────────────────
  auth: {
    signInHeading: 'ВОЙТИ',
    registerHeading: 'РЕГИСТРАЦИЯ',
    emailLabel: 'Email',
    passwordLabel: 'Пароль',
    confirmPasswordLabel: 'Подтвердите пароль',
    passwordPlaceholder: 'мин. 6 символов',
    confirmPlaceholder: 'повторите пароль',
    loading: 'ЗАГРУЗКА...',
    enterBtn: '▶ ВОЙТИ',
    createAccountBtn: '▶ СОЗДАТЬ АККАУНТ',
    noAccount: 'Нет аккаунта?\u00a0',
    createOne: 'Создать',
    alreadyRegistered: 'Уже зарегистрированы?\u00a0',
    signInLink: 'Войти',
    backToMap: 'На холст',
    passwordsNoMatch: 'Пароли не совпадают',
    registerSuccess: 'Регистрация успешна, проверьте email для подтверждения',
    loginError: 'Ошибка входа',
    registerError: 'Ошибка регистрации',
    oauthErrors: {
      unknown_provider: 'Неизвестный OAuth провайдер',
      invalid_state: 'Ошибка безопасности OAuth. Попробуйте снова',
      no_code: 'Авторизация отменена',
      userinfo_failed: 'Не удалось получить данные от провайдера',
      auth_failed: 'Ошибка аутентификации OAuth',
      oauth_failed: 'Ошибка входа через OAuth',
    },
    termTitleAuth: 'we-are-pixels · вход',
    termTitleRegister: 'we-are-pixels · регистрация',
    or: 'или',
  },

  // ── Verify ────────────────────────────────────────────────────────
  verify: {
    verifying: 'ПОДТВЕРЖДЕНИЕ EMAIL',
    pleaseWait: 'Пожалуйста, подождите...',
    success: 'УСПЕХ',
    redirecting: 'Перенаправление на вход через 3 секунды...',
    signInNow: '▶ ВОЙТИ СЕЙЧАС',
    error: 'ОШИБКА',
    invalidLink: 'Неверная ссылка подтверждения',
    confirmError: 'Ошибка подтверждения',
    backToMap: '← НА ХОЛСТ',
    termTitle: 'we-are-pixels · подтверждение',
  },

  // ── Profile ───────────────────────────────────────────────────────
  profile: {
    heading: 'ЛИЧНЫЙ КАБИНЕТ',
    emailLabel: 'Email',
    accountType: 'Тип аккаунта',
    oauthAccount: 'OAuth · {{provider}}',
    passwordAccount: 'Логин и пароль',
    registrationDate: 'Дата регистрации',
    changePassword: 'СМЕНИТЬ ПАРОЛЬ',
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    repeatPassword: 'Повторите новый пароль',
    saving: 'СОХРАНЕНИЕ...',
    saveBtn: 'СОХРАНИТЬ',
    passwordsNoMatch: 'Пароли не совпадают',
    passwordTooShort: 'Минимальная длина пароля — 6 символов',
    passwordChanged: 'Пароль успешно изменён',
    passwordChangeError: 'Ошибка смены пароля',
    oauthPasswordNote: 'Смена пароля недоступна для OAuth-аккаунтов',
    syntheticEmailHint: 'Сгенерирован провайдером OAuth',
    loadError: 'Не удалось загрузить профиль',
    zonePointTitle: 'СОЗДАТЬ ПИКСЕЛЬ В ЗОНЕ',
    zonePointZone: 'Активная зона',
    zonePointName: 'Имя пикселя',
    zonePointBtn: 'СОЗДАТЬ В ЗОНЕ',
    zonePointCreating: 'СОЗДАНИЕ...',
    zonePointCreated: 'Пиксель создан в выбранной зоне',
    zonePointError: 'Не удалось создать пиксель в зоне',
    zonePointNoZones: 'Нет активных зон',
    zonePointNoZonesHint: 'Сначала активируйте или купите зону, чтобы разместить в ней новый пиксель.',
    zonePointHint: 'Новый пиксель появится на ближайшей свободной клетке внутри выбранной активной зоны.',
    zonePointZoneRequired: 'Выберите зону для создания пикселя',
    zonePointLimit: 'Лимит пикселей',
    zonePointLimitReached: 'Лимит пикселей исчерпан. Удалите один из существующих пикселей или увеличьте лимит.',
    backToDashboard: '← К ДАШБОРДУ',
    termTitle: 'profile.exe',
  },

  // ── Home page ─────────────────────────────────────────────────────
  home: {
    playBtn : '▶ ИГРАТЬ',
    history: 'ИСТОРИЯ',
    signIn: 'ВОЙТИ',
    register: 'РЕГИСТРАЦИЯ',
    myPixels  : 'МОИ ПИКСЕЛИ',
    profileBtn: 'ПРОФИЛЬ',
    zonesBtn  : 'МОИ ЗОНЫ',
    shopBtn   : 'ПОДПИСКА',
    logout    : 'ВЫЙТИ',
  },

  // ── Dashboard ─────────────────────────────────────────────────────
  dashboard: {
    title: 'МОИ ПИКСЕЛИ',
    subtitle: '',
    backToMap: '← НА ХОЛСТ',
    profileBtn: 'ПРОФИЛЬ',
    adminBtn: 'АДМИН',
    logoutBtn: 'ВЫЙТИ',
    pointsStats: 'ПИКСЕЛЕЙ:',
    lastActive: 'ПОСЛЕДНЯЯ АКТИВНОСТЬ:',
    emptyLine1: 'ПИКСЕЛЕЙ ЕЩЁ НЕТ.',
    emptyLine2: 'СОЗДАЙТЕ ПЕРВЫЙ.',
    searchPlaceholder: 'ПОИСК ПО ИМЕНИ ИЛИ КООРДИНАТАМ...',
    noResults: 'НЕТ РЕЗУЛЬТАТОВ ДЛЯ "{{query}}"',
    prev: '← НАЗАД',
    next: 'ВПЕРЁД →',
    loading: 'ЗАГРУЗКА',
    errFetch: 'Не удалось загрузить пиксели',
    errCreate: 'Не удалось создать пиксель',
    errDelete: 'Не удалось удалить пиксель',
    errRename: 'Не удалось переименовать пиксель',
    errColor: 'Не удалось изменить цвет',
    shopBtn : 'ПОДПИСКА',
    zonesBtn: 'МОИ ЗОНЫ',
    subscriptionLabel: 'ПОДПИСКА:',
    subscriptionActiveUntil: 'АКТИВНА ДО {{date}}',
    subscriptionInactive: 'НЕ АКТИВНА',
    ownedColorsLabel: 'МОИ ЦВЕТА:',
    tabPixels : 'МОИ ПИКСЕЛИ',
    tabShop   : 'ПОДПИСКА',
    tabZones  : 'МОИ ЗОНЫ',
    tabProfile: 'ПРОФИЛЬ',
  },

  // ── Point card ────────────────────────────────────────────────────
  pointCard: {
    play: '▶ ИГРАТЬ',
    rename: '✎ ПЕРЕИМЕНОВАТЬ',
    color: '🎨 ЦВЕТ',
    del: '✕ УДАЛИТЬ',
    renameTitle: 'ПЕРЕИМЕНОВАТЬ ПИКСЕЛЬ',
    colorTitle: 'ВЫБРАТЬ ЦВЕТ',
    deleteTitle: 'УДАЛИТЬ ПИКСЕЛЬ?',
    deleteConfirm: '"{{name}}" будет удалён безвозвратно.',
    saveBtn: '✎ СОХРАНИТЬ',
    applyBtn: '✔ ПРИМЕНИТЬ',
    deleteBtn: '✕ УДАЛИТЬ',
    defaultColor: 'СТАНДАРТ',
  },

  // ── Create point ──────────────────────────────────────────────────
  createPoint: {
    btn: 'СОЗДАТЬ ПИКСЕЛЬ',
    limitReached: 'ЛИМИТ ПИКСЕЛЕЙ',
    title: 'СОЗДАТЬ ПИКСЕЛЬ',
    namePlaceholder: 'Мой Пиксель',
    hint: 'Оставьте пустым для имени по умолчанию. Координаты назначаются автоматически.',
    createBtn: '▶ СОЗДАТЬ',
  },

  // ── Game ──────────────────────────────────────────────────────────
  game: {
    pointLabel: 'ПИКСЕЛЬ #{{id}}',
    colorLabel: 'ЦВЕТ:',
    pointsLabel: 'ПИКСЕЛЕЙ:',
    dashboardBtn: 'ДАШБОРД',
    canvasBtn: 'ХОЛСТ',
    colorBtn: 'ЦВЕТ',
    addPointBtn: 'ПИКСЕЛЬ',
    moreActions: 'ЕЩЁ',
    controlsLayout: 'УПРАВЛЕНИЕ',
    controls_onehand: 'ОДНА РУКА',
    controls_split: 'ДВЕ РУКИ',
    controls_taps: 'ОБЛАСТИ',
    controlsHand: 'РУКА',
    hand_right: 'ПРАВАЯ',
    hand_left: 'ЛЕВАЯ',
    controlsSize: 'РАЗМЕР D-PAD',
    size_compact: 'КОМПАКТ',
    size_large: 'КРУПНЫЙ',
    controlsGridBrightness: 'ЯРКОСТЬ СЕТКИ',
    switchPixelBtn: 'СМЕНА',
    switchPixelHint: 'НАЖМИТЕ НА ПИКСЕЛЬ ДЛЯ СМЕНЫ — ФОН ДЛЯ ОТМЕНЫ',
    createPointTitle: 'СОЗДАТЬ ПИКСЕЛЬ',
    namePlaceholder: 'Имя (необязательно)',
    chooseColorTitle: 'ВЫБРАТЬ ЦВЕТ',
    gridOn: 'СЕТКА ВКЛ',
    gridOff: 'СЕТКА ВЫКЛ',
    creating: '...',
    createBtn: 'СОЗДАТЬ',
    errCreate: 'Не удалось создать пиксель',
    errColor: 'Не удалось изменить цвет',
    deletePointBtn: 'УДАЛИТЬ',
    deleteConfirmTitle: 'УДАЛИТЬ ПИКСЕЛЬ?',
    deleteConfirmText: 'Пиксель #{{id}} будет удалён безвозвратно.',
    deleteConfirmBtn: 'УДАЛИТЬ',
    errDelete: 'Не удалось удалить пиксель',
    helpBtn: 'ПОМОЩЬ',
    helpTitle: 'КАК ИГРАТЬ',
    helpMove: 'Переместить пиксель',
    helpColor: 'Открыть палитру цветов',
    helpGrid: 'Показать/скрыть сетку',
    helpCreate: 'Создать новый пиксель',
    helpDelete: 'Удалить текущий пиксель',
    helpImpassable: 'Переключить стену (непроходимость)',
    sayBtn        : 'СКАЗАТЬ',
    sayPlaceholder: 'Написать сообщение...',
    sayJump       : 'ПРЫЖОК',
    jumpBtn       : 'ПРЫЖОК',
    gotoBtn        : 'ИДТИ К',
    gotoCancel     : 'ОТМЕНА',
    gotoHint       : 'НАЖМИТЕ КЛЕТКУ — ПОСТАВИТЬ ЦЕЛЬ',
    gotoGo         : 'ИДТИ',
    gotoStop       : 'СТОП',
    gotoWalking    : 'ИДУ…',
    gotoUnreachable: 'Не получается дойти до клетки',

    helpSectionControls : 'УПРАВЛЕНИЕ (КЛАВИАТУРА)',
    helpSectionHud      : 'КНОПКИ ИНТЕРФЕЙСА',
    helpSectionMechanics: 'МЕХАНИКИ',
    helpSectionColors   : 'ЦВЕТА',
    helpSectionZones    : 'ЗОНЫ',

    helpHudDashboard: 'ДАШБОРД — список ваших пикселей',
    helpHudCanvas   : 'ХОЛСТ — вернуться на главный холст',
    helpHudColor    : 'ЦВЕТ — изменить цвет текущего пикселя',
    helpHudPoint    : 'ПИКСЕЛЬ — создать новый пиксель',
    helpHudSwitch   : 'СМЕНА — нажмите на свой пиксель на карте для переключения',
    helpHudZone     : 'ЗОНА — создать или управлять бронированиями зон',
    helpHudGrid     : 'СЕТКА — включить/выключить координатную сетку',
    helpHudShare    : 'ПОДЕЛИТЬСЯ — скопировать ссылку на текущий вид',
    helpHudGoto     : 'ИДТИ К — нажмите клетку, затем ИДТИ, и пиксель сам дойдёт туда',
    helpHudWall     : 'СТЕНА — сделать пиксель непроходимым (требует активную зону)',
    helpHudDelete   : 'УДАЛИТЬ — безвозвратно удалить текущий пиксель',
    helpHudSay      : 'СКАЗАТЬ — отправить речевой пузырь всем наблюдателям (клавиша T)',
    helpSay         : 'Открыть / закрыть ввод сообщения',
    helpSayJump     : 'Открыть ввод сообщения с прыжком',
    helpJump        : 'Прыжок (виден всем)',
    speechStyleLocked: 'Стили реплик доступны только по подписке',

    helpMechMove  : 'Движение в 4 направлениях. Занятые клетки пропускаются — вы перепрыгиваете на следующую свободную клетку в том же направлении.',
    helpMechRate  : 'Ограничение скорости: 5 ходов в секунду (задержка 200 мс).',
    helpMechSync  : 'Поле синхронизируется мгновенно при каждом ходе и каждую секунду.',
    helpMechCreate: 'Новые пиксели появляются на ближайшей свободной клетке от центра мира (0, 0) методом BFS.',

    helpColorFree   : '16 бесплатных цветов — доступны всем пользователям.',
    helpColorPremium: 'Премиум-цвета — купить по отдельности (9 ₽) или по подписке (199 ₽/мес).',
    helpColorCustom : 'Любой hex-цвет — только при активной подписке.',

    helpZoneDesc   : 'Забронируйте прямоугольную область (мин. 100×100 клеток). Чужие пиксели, простаивающие внутри, выселяются по истечении таймаута.',
    helpZoneWarning: 'Предупреждение о выселении поступает за 15 секунд до истечения таймаута.',
    helpZoneFree   : 'Зоны дальше 3000 единиц от начала координат (0, 0) — бесплатны (1 на пользователя, макс. 100×100).',
    helpZoneWall   : 'СТЕНА не даёт другим пикселям перепрыгнуть через ваш. Работает только внутри активной зоны. При выселении стена снимается.',

    impassableOn: 'СТЕНА: ВКЛ',
    impassableOff: 'СТЕНА: ВЫКЛ',
    errImpassable: 'Не удалось изменить статус стены',
  },

  // ── History ───────────────────────────────────────────────────────
  history: {
    backBtn: '← НАЗАД',
    playerTitle: 'ПЛЕЕР ИСТОРИИ',
    timeLabel: 'ВРЕМЯ',
    viewLabel: 'ОБЗОР',
    fromLabel: 'ОТ',
    toLabel: 'ДО',
    loadingBtn: 'ЗАГРУЗКА...',
    reloadBtn: 'ОБНОВИТЬ',

    staleReload: 'ОБНОВИТЬ ОБЛАСТЬ',


    activityHint: 'Таймлайн: тяните для прокрутки, колёсико/щипок — масштаб, жёлтая лента — диапазон (тяните её или края), клик — перемотка, долгое нажатие или двойной клик — перенести диапазон сюда.',    truncated: 'показаны первые {{total}}+ — сузьте область или время',



    timelineExpand: 'Развернуть таймлайн',


    timelineCollapse: 'Свернуть таймлайн',


    loadingEvents: 'загрузка событий… {{n}}',


    activityLoading: 'считается активность…',    truncatedHint: 'Событий в диапазоне больше, чем загружено. Плеер проигрывает только загруженную часть.',    loadBtn: 'ЗАГРУЗИТЬ',
    events: '{{index}} / {{total}} событий',
    eventsEmpty: '—',
    modeLabel: 'РЕЖИМ',
    fixedMode: 'ФИКСИРОВАННЫЙ',
    realtimeMode: 'РЕАЛЬНОЕ ВРЕМЯ',
    evtPerS: 'СОБ/С',
    speedLabel: 'СКОРОСТЬ',
    autoplayLabel: 'АВТОЗАПУСК',
    autoplayHint: 'Добавляет ?play=1 в ссылку — у открывшего её воспроизведение начнётся само',
    loadError: 'ошибка загрузки',
    setup: 'НАСТРОЙКИ',
    playTitle: 'Воспроизвести',
    pauseTitle: 'Пауза',
    resetTitle: 'В начало',
    record: 'ЗАПИСЬ',
    recordTitle: 'Записать таймлапс',
    recording: 'ИДЁТ ЗАПИСЬ…',
    stop: 'СТОП',
    stopTitle: 'Остановить и сохранить',
    encoding: 'КОДИРОВАНИЕ {{pct}}%',
    recordArea: 'ОБЛАСТЬ',
    selectArea: 'ВЫДЕЛИТЬ ОБЛАСТЬ',
    reselectArea: 'ПЕРЕВЫБРАТЬ',
    selectAreaHint: 'Выделите прямоугольник — это будет кадр записи',
    frameMoveHint: 'Тяните, чтобы передвинуть область; за углы и края — изменить размер',
    recordViewport: 'текущий вид',
    recordLoadFirst: 'Сначала загрузите события',
    recordUnsupported: 'Запись не поддерживается в этом браузере',
    recordGifNote: 'GIF-фолбэк (нет поддержки видео)',
    recordSaved: 'Таймлапс сохранён',
    recordFailed: 'Не удалось записать',
  },

  // ── Admin ─────────────────────────────────────────────────────────
  admin: {
    title: 'ПАНЕЛЬ АДМИНИСТРАТОРА',
    backToDashboard: '← ДАШБОРД',
    tabs: {
      users: 'ПОЛЬЗОВАТЕЛИ',
      stats: 'СТАТИСТИКА',
      events: 'ПОСЛЕДНИЕ ДЕЙСТВИЯ',
      import: 'ИМПОРТ КАРТИНКИ',
      zones: 'ЗОНЫ',
      maze: 'ЛАБИРИНТ',
      dialogue: 'ДИАЛОГИ',
      connections: 'ПОДКЛЮЧЕНИЯ',
    },
    connections: {
      loadError: 'Ошибка загрузки подключений',
      totalLabel: 'Всего',
      playersLabel: 'Игроки',
      observersLabel: 'Наблюдатели',
      refreshHint: 'Обновляется каждые 3 с',
      showList: 'Показать детали',
      hideList: 'Скрыть детали',
      noConnections: 'Нет активных подключений',
      colUser: 'Пользователь',
      colPoint: 'Пиксель',
      colType: 'Тип',
      colIP: 'IP',
      colArea: 'Область',
      colDuration: 'Длительность',
      typePlayer: 'игрок',
      typeObserver: 'наблюдатель',
      prev: '‹ назад',
      next: 'вперёд ›',
      pageInfo: '{{from}}–{{to}} из {{total}}',
    },
    users: {
      searchPlaceholder: 'Поиск по email...',
      searchBtn: 'НАЙТИ',
      loadError: 'Ошибка загрузки пользователей',
      loadingText: 'загрузка...',
      colId: 'ID',
      colEmail: 'Email',
      colVerified: 'Верифицирован',
      colAdmin: 'Админ',
      colPixels: 'Пикселей',
      colMoves: 'Ходов',
      colMaxPoints: 'Max points',
      colOAuth: 'OAuth',
      colActions: 'Действия',
      editBtn: 'ред.',
      deleteBtn: 'удал.',
      editTitle: 'Редактировать: {{email}}',
      maxPointsLabel: 'Max points',
      isAdminLabel: 'Администратор',
      savingBtn: 'СОХРАНЕНИЕ...',
      saveBtn: 'СОХРАНИТЬ',
      cancelBtn: 'ОТМЕНА',
      deleteConfirm: 'Удалить пользователя {{email}}?',
    },
    stats: {
      loadError: 'Ошибка загрузки статистики',
      loadingText: 'загрузка...',
      daysBtn: '{{days}} дней',
      moves: 'перемещений',
      created: 'создано',
      deleted: 'удалено',
      movesTooltip: '{{day}}: {{count}} ходов',
      noData: 'нет данных',
    },
    events: {
      loadError: 'Ошибка загрузки событий',
      loadingText: 'загрузка...',
      colTime: 'Время',
      colType: 'Тип',
      colUser: 'Пользователь',
      colPixel: 'Пиксель',
      colCoords: 'Координаты',
      colColor: 'Цвет',
      typeMove: 'ход',
      typeCreated: 'создан',
      typeDeleted: 'удалён',
      typeUpdated: 'обновлён',
    },
    import: {
      hint: 'Загрузите изображение — пиксели выбранного цвета (чёрные или белые) будут размещены на поле начиная с координаты (X, Y). Занятые ячейки пропускаются.',
      imageLabel: 'Изображение (PNG / JPEG / GIF)',
      startXLabel: 'Начало X',
      startYLabel: 'Начало Y',
      colorModeLabel: 'Размещать пиксели цвета',
      blackBtn: 'ЧЁРНЫЕ',
      whiteBtn: 'БЕЛЫЕ',
      thresholdLabel: 'Порог яркости: {{value}}',
      thresholdBlack: 'яркость < {{value}}',
      thresholdWhite: 'яркость > {{value}}',
      pixelColorLabel: 'Цвет размещаемых пикселей',
      selectImageError: 'Выберите изображение',
      importError: 'Ошибка импорта',
      result: '{{created}} размещено · {{skipped}} пропущено',
      importingBtn: 'ИМПОРТ...',
      importBtn: 'ИМПОРТИРОВАТЬ',
    },
    maze: {
      hint: 'Выберите область на карте. В ней будет сгенерирован лабиринт из непроходимых стен, а зона — зарезервирована на ваше имя.',
      nameLabel: 'Название',
      namePlaceholder: 'Название лабиринта',
      wallColorLabel: 'Цвет стен',
      selectBtn: 'ВЫБРАТЬ ОБЛАСТЬ НА КАРТЕ',
      selectAreaError: 'Сначала выберите область на карте',
      selectedArea: 'Выбрано: ({{x1}}, {{y1}}) → ({{x2}}, {{y2}}) — {{w}}×{{h}} клеток',
      generateBtn: 'СГЕНЕРИРОВАТЬ ЛАБИРИНТ',
      generatingBtn: 'ГЕНЕРАЦИЯ...',
      result: 'Готово! Зона #{{zone_id}}, размещено {{walls}} стен. Вход: ({{ex}}, {{ey}}), Выход: ({{exitx}}, {{exity}})',
      error: 'Ошибка генерации',
      animateLabel: 'Строить постепенно (для машины времени)',
      animatePaceMs: '{{ms}} мс на стену',
    },
    dialogue: {
      hint: 'Соберите сцену из двух пикселей: выберите существующие или создайте новые, задайте координаты и проиграйте последовательность реплик и прыжков.',
      actorA: 'ПИКСЕЛЬ A',
      actorB: 'ПИКСЕЛЬ B',
      pickExistingBtn: 'СУЩЕСТВУЮЩИЙ',
      createNewBtn: 'НОВЫЙ',
      pointLabel: 'Пиксель',
      pointSearchPlaceholder: 'Поиск пикселя по id, имени или email...',
      pickOnMapBtn: 'ВЫБРАТЬ НА КАРТЕ',
      ownerLabel: 'Владелец',
      nameLabel: 'Имя',
      namePlaceholder: 'Имя пикселя',
      xLabel: 'X',
      yLabel: 'Y',
      createPointBtn: 'СОЗДАТЬ ПИКСЕЛЬ',
      savePointBtn: 'СОХРАНИТЬ ПОЗИЦИЮ',
      createOnMapBtn: 'СОЗДАТЬ НА КАРТЕ',
      moveOnMapBtn: 'ПЕРЕМЕСТИТЬ НА КАРТЕ',
      scriptTitle: 'СЦЕНАРИЙ',
      timelineTitle: 'ПРЕДПРОСМОТР ТАЙМЛАЙНА',
      timelineDuration: 'Длительность: {{duration}}',
      timelineSayPreview: 'Фраза: {{text}}',
      timelineJumpPreview: 'Прыжок',
      timelineJumpFlag: 'с подпрыгиванием',
      timelineDelayFlag: 'задержка {{delay}}',
      importBtn: 'ЗАГРУЗИТЬ JSON',
      exportBtn: 'ВЫГРУЗИТЬ JSON',
      addStepBtn: '+ ШАГ',
      playBtn: '▶ ПРОИГРАТЬ',
      playingBtn: 'ПРОИГРЫВАЕТСЯ...',
      stopBtn: 'СТОП',
      cmdSay: 'СКАЗАТЬ',
      cmdJump: 'ПРЫГНУТЬ',
      deleteStepBtn: 'УДАЛИТЬ',
      textPlaceholder: 'Текст реплики',
      styleLockedHint: 'Стили реплик доступны только владельцам пикселя с активной подпиской',
      jumpWithSayLabel: 'Подпрыгнуть вместе с репликой',
      mapPickExisting: 'Выберите существующий пиксель кликом по миру',
      mapPickPosition: 'Выберите клетку на карте для создания или перемещения',
      mapPickExistingHint: 'Кликните по уже существующему пикселю на реальном поле.',
      mapPickPositionHint: 'Кликните по свободной или нужной клетке на реальном поле.',
      mapNoPoint: 'В этой клетке нет пикселя.',
      errUserRequired: 'Для нового пикселя выберите владельца',
      errPointRequired: 'Сначала выберите пиксель',
      errPointLookup: 'Не удалось загрузить выбранный пиксель',
      errSavePoint: 'Не удалось сохранить пиксель',
      errAllActorsReady: 'Оба пикселя должны быть созданы или выбраны',
      errEmptySpeech: 'Реплика не может быть пустой',
      errPlay: 'Не удалось проиграть сценарий',
      errImportInvalid: 'Некорректный файл сценария',
    },
    zones: {
      searchPlaceholder: 'Поиск по email владельца или названию зоны...',
      loadError        : 'Не удалось загрузить зоны',
      deleteConfirm    : 'Удалить зону «{{name}}»?',
      createBtn        : '+ СОЗДАТЬ ЗОНУ',
      createTitle      : 'СОЗДАТЬ ЗОНУ ДЛЯ ПОЛЬЗОВАТЕЛЯ',
      userIdLabel          : 'Пользователь',
      userSearchPlaceholder: 'Поиск пользователя по email...',
      coordsLabel      : 'Координаты',
      isFreeLabel      : 'Бесплатная (постоянная, без оплаты)',
      expiresAtLabel   : 'Активна до',
      errUserId        : 'Введите корректный ID пользователя',
      errCreate        : 'Не удалось создать зону',
      errUpdate        : 'Не удалось обновить зону',
      editTitle        : 'РЕДАКТИРОВАТЬ ЗОНУ #{{id}}',
      colId            : 'ID',
      colOwner         : 'Владелец',
      colName          : 'Название',
      colCoords        : 'Координаты',
      colTimeout       : 'Таймаут',
      colStatus        : 'Статус',
      colExpires       : 'Истекает',
      statusFree       : 'БЕСПЛАТНО',
      statusActive     : 'АКТИВНА',
      statusPending    : 'ОЖИДАЕТ',
    },
  },

  speech: {
    styleLabel: 'Стиль реплики',
    styleLockedHint: 'Выбор стиля доступен только по подписке',
    stylePreview: 'стиль: {{style}}',
    styles: {
      default: 'Обычный',
      cloud: 'Облако',
      neon: 'Неон',
      pixel: 'Пиксель',
    },
  },

  // ── Магазин ────────────────────────────────────────────────────────
  shop: {
    title: 'МАГАЗИН ЦВЕТОВ',
    subtitle: 'разблокируй больше цветов',
    backBtn: '← ДАШБОРД',
    subscriptionTitle: 'ВСЕ ЦВЕТА · ПОДПИСКА',
    subscriptionDesc: 'Доступ ко всем премиум-цветам и любому hex-цвету.',
    perk1: 'Все премиум-цвета из палитры',
    perk2: 'Любой hex-цвет (#RRGGBB)',
    perk3: 'Месяцы накапливаются — продлевай в любой момент',
    inactive: 'Подписка не активна',
    activeUntil: 'Активна до {{date}}',
    subPrice: '199 ₽ / мес',
    subscribeBtn: '▶ ПОДПИСАТЬСЯ',
    extendBtn: '▶ ПРОДЛИТЬ',
    premiumTitle: 'ПРЕМИУМ ЦВЕТА · КУПИТЬ ОДИН',
    premiumHint: 'Купите отдельный цвет навсегда.',
    customTitle: 'ПРОИЗВОЛЬНЫЙ HEX · ТОЛЬКО ПО ПОДПИСКЕ',
    customHint: 'Любой цвет, введённый вручную, доступен только по подписке.',
    customAny: '...и любой из 16 миллионов цветов',
    freeTitle: 'БЕСПЛАТНЫЕ ЦВЕТА',
    freeHint: 'Доступны всем пользователям без оплаты.',
    free: 'БЕСПЛАТНО',
    owned: '✔ КУПЛЕН',
    buyFor: 'Купить за',
    lockedHint: '🔒 Заблокировано — купите или подпишитесь',
    hexLockedHint: 'Не разблокировано.',
    buyColorBtn: '🔓 Купить 9 ₽',
    colorAlreadyOwned: 'Уже в коллекции',
    goToShop: 'Или подписка →',
    errBuy: 'Не удалось купить цвет',
    errSub: 'Не удалось активировать подписку',
    paymentSuccess: 'Оплата прошла успешно! Покупка активирована.',
    paymentFail: 'Оплата отменена или не прошла. Попробуйте снова.',
  },

  // ── Зоны ──────────────────────────────────────────────────────────
  zone: {
    reserveBtn      : 'ЗОНА',
    reserveTitle    : 'ЗАБРОНИРОВАТЬ ОБЛАСТЬ',
    namePlaceholder : 'Название зоны',
    timeoutLabel    : 'Выселить через (простой)',
    seconds         : 'с',
    createBtn       : '▶ ЗАБРОНИРОВАТЬ',
    myZones         : 'МОИ ЗОНЫ В ЭТОЙ ОБЛАСТИ',
    created         : 'Зона успешно забронирована',
    deleted         : 'Зона удалена',
    errCreate       : 'Не удалось создать зону',
    errDelete       : 'Не удалось удалить зону',
    errInvalidCoords: 'Неверные координаты',
    evictionWarning : '⚠ Зона «{{name}}» — вы будете выселены через {{seconds}} с',
    evicted         : 'Вас выселили из зоны «{{name}}»',
    zonesOn         : 'ЗОНЫ ВКЛ',
    zonesOff        : 'ЗОНЫ ВЫКЛ',
    drawBtn         : '📐 ВЫДЕЛИТЬ',
    drawInstruction : 'Зажмите и выделите область на карте',
    drawCancelBtn   : '✕ Отмена',
    priceLabel      : 'СТОИМОСТЬ:',
    priceFree       : 'БЕСПЛАТНО (приграничная зона)',
    priceAmount     : '{{amount}} ₽/месяц',
    priceCalculating: 'считаем...',
    freeHint              : 'Зоны дальше 3000 единиц от начала координат (0, 0) — бесплатны (1 на пользователя).',
    freeHint2             : 'Квота бесплатных зон исчерпана. Эта приграничная зона будет оплачена по минимальному тарифу.',
    expiresAt             : 'до {{date}}',
    pendingPayment        : 'ожидает оплаты',
    paymentSuccess        : 'Оплата зоны прошла успешно! Зона активирована.',
    renewSuccess          : 'Зона продлена ещё на месяц.',
    errRenew              : 'Не удалось продлить зону',
    overlapWarning        : '⚠ Эта область пересекается с существующей зоной.',
    deleteConfirmTitle    : 'УДАЛИТЬ ЗОНУ?',
    deleteConfirmText     : 'Зона «{{name}}» будет удалена безвозвратно.',
    deleteConfirmBtn      : '✕ УДАЛИТЬ',
    deleteNoRefund        : 'Зона оплачена. При досрочном удалении деньги не возвращаются.',
    expiringWarning       : '⚠ Зона «{{name}}» истекает через {{days}} дн. Продлите, чтобы сохранить.',
    renewBtn              : '↻ ПРОДЛИТЬ',
    renewingBtn           : 'ПРОДЛЕНИЕ...',
    expiringSoonBanner    : '{{count}} зон(ы) истекают — продлите, чтобы не потерять.',
  },

  // ── Мои зоны ──────────────────────────────────────────────────────
  myZones: {
    title        : 'МОИ ЗОНЫ',
    subtitle     : 'забронированные области',
    empty        : 'У вас пока нет забронированных зон.',
    createBtn    : 'ЗАБРОНИРОВАТЬ ЗОНУ',
    coordsLabel  : 'Координаты',
    statFree     : 'БЕСПЛАТНАЯ ЗОНА:',
    statTotal    : 'ВСЕГО ЗОН:',
    statusFree   : 'БЕСПЛАТНО',
    statusActive : 'АКТИВНА',
    statusExpired: 'ИСТЕКЛА',
    statusPending: 'ОЖИДАЕТ ОПЛАТЫ',
    deleteConfirm: 'Удалить зону «{{name}}»?',
    payBtn       : '▶ ОПЛАТИТЬ {{amount}} ₽',
    freeQuotaUsed: 'Квота бесплатных приграничных зон исчерпана. Дополнительные зоны оплачиваются по минимальному тарифу.',
  },

  // ── Language switcher ─────────────────────────────────────────────
  lang: {
    en: 'EN',
    ru: 'RU',
  },

  // ── Cookie banner ─────────────────────────────────────────────────
  cookie: {
    text      : 'Мы используем cookies для аутентификации и анонимной аналитики (Яндекс.Метрика, Google Analytics). Сбор статистики начнётся только после вашего согласия.',
    learnMore : 'Подробнее',
    accept    : 'ПОНЯТНО',
  },

  // ── Индикатор соединения ─────────────────────────────────────────
  connDot: {
    status: {
      connecting   : 'Подключение…',
      connected    : 'Подключено',
      reconnecting : 'Переподключение…',
      disconnected : 'Нет соединения',
    },
    lastMessage : 'Последнее сообщение',
    msgCount    : 'Получено сообщений',
    never       : 'никогда',
  },

  // ── О проекте ─────────────────────────────────────────────────────
  about: {
    termTitle   : 'about.exe',
    heading     : 'О ПРОЕКТЕ',
    tabs: {
      about    : 'О НАС',
      help     : 'ПОМОЩЬ',
      contacts : 'КОНТАКТЫ',
      oferta   : 'ОФЕРТА',
      privacy  : 'КОНФИДЕНЦ.',
    },
    desc1       : 'We Are Pixels — многопользовательский коллаборативный холст, где каждый зарегистрированный пользователь управляет одним пикселем в бесконечном двумерном мире.',
    desc2       : 'Тысячи пикселей вместе создают живой пиксель-арт, видимый в реальном времени каждому посетителю. Без чата и инструментов координации — только движение.',
    desc3       : 'Возможности:',
    feat1       : 'Мир в реальном времени — наблюдайте за движением пикселей',
    feat2       : 'Плеер истории — перематывайте события прошлого',
    feat3       : 'Бронирование зон — займите и защитите свою территорию',
    feat4       : 'Магазин цветов — разблокируйте премиум и произвольные цвета',
    version     : 'Версия 1.0 · 2025',
    emailLabel  : 'Email',
    telegramLabel: 'Telegram',
    legalLabel  : 'Юридическое лицо',
    legalName   : 'We Are Pixels',
    ofertaTitle : 'ДОГОВОР ПУБЛИЧНОЙ ОФЕРТЫ',
    aboutBtn    : 'О ПРОЕКТЕ',
  },
} as const;

export default ru;
